// executiveDashboard module index.js

const state = {
  brands: [],
  executiveSummaries: [],
  loading: false,
  error: null
};

import mutations from './mutations'
import actions from './actions'
import getters from './getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
